import imgCaelus101 from "./img-caelus10 (1).webp";
import imgCaelus102 from "./img-caelus10 (2).webp";
import imgCaelus103 from "./img-caelus10 (3).webp";
import imgCaelus104 from "./img-caelus10 (4).webp";

const imgCaelus10 = [imgCaelus101, imgCaelus102, imgCaelus103, imgCaelus104];

export default imgCaelus10;
